<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      size: '*',
      visible: true
    }
  ]"
  definition="Birimler"
  [mode]="'DIALOG'"
  [closeInside]="true"
  [modalClass]="'modal-dialog short-modal'"
  [filterSelectItems]="filterSelectItems"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'unit',
    name: 'units',
    form: 'UNITS',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'MATERIAL_MANAGEMENT'"
  [moduleName]="'UNITS_LIST'"
  [gridName]="'grdUnitsList'"
>
</kl-grid>
